import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "show-more-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.6591 4.39307C13.0733 4.39307 13.4091 4.72885 13.4091 5.14307C13.4091 5.55728 13.0733 5.89307 12.6591 5.89307H5.69482V12.8574C5.69482 13.2716 5.35904 13.6074 4.94482 13.6074C4.53061 13.6074 4.19482 13.2716 4.19482 12.8574V5.14307C4.19482 4.72885 4.53061 4.39307 4.94482 4.39307H12.6591Z" }, null, -1),
    _createElementVNode("path", { d: "M10.9449 19.6074C10.5307 19.6074 10.1949 19.2716 10.1949 18.8574C10.1949 18.4431 10.5307 18.1074 10.9449 18.1074H17.9092V11.1431C17.9092 10.7289 18.2449 10.3931 18.6592 10.3931C19.0734 10.3931 19.4092 10.7289 19.4092 11.1431V18.8574C19.4092 19.2716 19.0734 19.6074 18.6592 19.6074H10.9449Z" }, null, -1)
  ])))
}
export default { render: render }